<!--竞价中心-->
<template>
  <div class="priceCentre">
    <div :style="priceStyle">
      <div class="top">
        <div class="pricediv">
          <span class="p1">{{name}}</span>
          <br />
          <span class="p2">{{about}}</span>
          <br />
          <a class="in-price" href="#" @click="jumpToList(url,biztype)">{{come}}</a>
        </div>
      </div>
    </div>
    <div class="price-content">
      <div class="price-title">
        <span class="title-type">{{state}}</span>
        <span class="center-title">{{biddingtitle}}</span>
        <span class="organize">{{puborg}}</span>
        <span class="publish-time">{{pubdate}}</span>
      </div>
      <div class="price-border-bottom"></div>
      <div class="price-list">
        <ul>
          <li v-for="(category,i) in categorys.slice(0,5)" :key="i">
            <a href="#" @click="jumpToDetail(category.noticeId)">
              <span
                class="status"
                :title="category.status.value"
                :class="addclassStatus(category.status.num)"
              >{{category.status.value}}</span>
              <span class="title-content" :title="category.noticeName">{{category.noticeName}}</span>
              <span class="organize-content">{{category.org}}</span>
              <span class="time-content">{{category.publish_time.substring(0,11)}}</span>
            </a>
          </li>
        </ul>
        <div class="tender-a">
          <a href="#" @click="showbut" :style="tender">{{moreview}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import axios from '@/utils/http'; // 导入http中创建的axios实例

export default {
  data() {
     //常量
    // let constant = JSON.parse(this.$supMainPageConfig).constant;
    // let categoryShow = JSON.parse(this.$supMainPageConfig);
    // this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    // let categoryInfo1 = JSON.parse(this.$supMainPageConfig).categoryInfoShow.categoryInfo1[2];
    return {
      // moreview: constant.moreview,
      // state: constant.state,
      // biddingtitle: constant.biddingtitle,
      // puborg: constant.puborg,
      // pubdate: constant.pubdate,
      // name: categoryInfo1 && categoryInfo1.category && categoryInfo1.category.name,
      // about: JSON.parse(this.$supMainPageConfig).catItemImg.info3.about,
      // come: categoryInfo1 && categoryInfo1.category && categoryInfo1.category.come,
      // url: categoryInfo1 && categoryInfo1.category && categoryInfo1.category.url,
      // categorys: categoryInfo1 && categoryInfo1.info,
      // biztype: categoryInfo1 && categoryInfo1.biztype,
      show: false,
      //showT: this.theme,
      priceshow: false
    };
  },
  methods: {
    jumpToDetail(noticeId) {
      let param = "";
      param = "&noticeId=" + noticeId + "&noticeName=quo_bidbill";
      const base = axios.defaults.baseURL;
      let url = base + "/index.html?formId=quo_notice" + param;
      window.open(url, "_blank");
    },
    jumpToList(link) {
      window.open(link, "_blank");
    },
    showbut() {
      this.$emit("funckk", this.show);
    },
    addclassStatus(status) {
      switch (status) {
        case "16":
          return "statustypea";
        case "17":
          return "statustypeh";
        case "18":
          return "statustypeb";
        case "19":
          return "statustypec";
        case "20":
          return "statustyped";
        case "12":
          return "statustypee";
        case "13":
          return "statustypef";
        case "14":
          return "statustypeg";
        case "21":
          return "statustypeh";
        case "15":
          return "statustypei";
      }
    }
  },
  computed: {
       //store里面取数据
    ...mapGetters(['supMainPageConfig']),
  moreview: function()  {
      return JSON.parse(this.supMainPageConfig).constant.moreview;
    },
  state: function()  {
      return JSON.parse(this.supMainPageConfig).constant.state;
    },
  biddingtitle: function()  {
      return JSON.parse(this.supMainPageConfig).constant.biddingtitle;
    },
  puborg: function()  {
      return JSON.parse(this.supMainPageConfig).constant.puborg;
    },
  pubdate: function()  {
      return JSON.parse(this.supMainPageConfig).constant.pubdate;
    },
  name: function()  {
      return JSON.parse(this.supMainPageConfig).categoryInfoShow.categoryInfo1[2].category.name;
    },
  about: function()  {
      return JSON.parse(this.supMainPageConfig).catItemImg.info3.about;
    },

  come: function()  {
      return JSON.parse(this.supMainPageConfig).categoryInfoShow.categoryInfo1[2].category.come;
    },
  url: function()  {
      return JSON.parse(this.supMainPageConfig).categoryInfoShow.categoryInfo1[2].category.url;
    },
  categorys: function()  {
      return JSON.parse(this.supMainPageConfig).categoryInfoShow.categoryInfo1[2].info;
    },
  biztype: function()  {
      return JSON.parse(this.supMainPageConfig).categoryInfoShow.categoryInfo1[2].biztype;
    },
  showT: function()  {
      return JSON.parse(this.supMainPageConfig).catItemImg.info7.theme
    },
  


    priceStyle: function() {
      let priceImgSrc = JSON.parse(this.supMainPageConfig).catItemImg.info3
        .priceImgSrc;
      return {
        backgroundImage: "url(" + priceImgSrc + ")",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "220px",
        backgroundSize: "100% 100%"
      };
    },
    tender: function() {
      if (this.showT == 1) {
        return {
          color: " #4a98ff",
          textDecoration: "none",
          fontSize: "14px",
          float:"right",
          marginRight: "22px"
        };
      }
      if (this.showT == 2) {
        return {
          color: " #6869FB",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
      if (this.showT == 3) {
        return {
          color: " #29C392",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
      if (this.showT == 4) {
        return {
          color: " #FC8555",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
    }
  },
  props: ["priceshow"]
};
</script>

<style scoped lang="scss">
.pricediv {
  width: 1200px;
  margin: 0 auto;
}
.priceCentre {
  width: 100%;
  margin: 0 auto;
  margin-top: 64px;
}
.top {
  padding-top: 16px;
}
.top .p1 {
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 56px;
  letter-spacing: 2px;
}
.top .p2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}
.top .in-price {
  display: inline-grid;
  margin-top: 22px;
  //width: 126px;
  width: 180px;
  height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(107, 110, 131, 1);
  line-height: 32px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border-radius: 4px;
  border: 0px;
  text-align: center;
  text-decoration: none;
}
.price-content {
  width: 1200px;
  height: 347px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: -50px;
  border-radius: 5px;
}
.price-title {
  margin-left: 24px;
  padding-top: 26px;
  display: flex; // ---
}
.price-title span:not(.title-type) { // ----
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  letter-spacing: 1px;
  font-weight: bold;
  flex: 1; // ---
}
.price-title span.title-type { // ---
  display: inline-block; // ---
  width: 96px; // ---
  margin-right: 60px; // ---
  font-weight: 700;
}
.price-title span.center-title {
  //margin-left: 32px;
  // margin-left: 150px; // ---
}
.price-title span.organize {
  //margin-left: 502px;
    // margin-left: 250px; // ---
}

.price-title span.publish-time {
  //margin-left: 355px;
  // margin-left: 255px; // ---
}

.price-border-bottom {
  margin-left: 24px;
  margin-right: 22px;
  margin-top: 22px;
  border-top: 1px solid #dadada;
}
.price-list ul {
  list-style: none;
  padding-left: 24px;
}
.price-list ul li a {
  color: inherit;
  text-decoration: none;
  display: flex; // ---
}

.price-list ul li a:hover {
  background-color: #f2f6fc;
}

.price-list img {
  width: 45px;
  height: 18px;
  align-items: center;
  margin-right: 12px;
  vertical-align: sub;
}
.price-list ul li {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(41, 44, 64, 1);
  line-height: 22px;
  margin-bottom: 22px;
}

//状态类型
.price-list ul li .status {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 60px; // ---
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 96px;
}

.price-list ul li .title-content {
  // width: 495px; // ---
  // padding-right: 74px; // ---
  //display: inline-block; // ---
  max-width: 495px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  //margin-left: 12px;
  // margin-left: 115px; // ---
  flex: 1; // ---
}

.price-list ul li .organize-content {
  // width: 274px; // ---
  // padding-right: 150px; // ---
  // display: inline-block; // ---
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1; // ---
   //间距
  // margin-left: -260px; // ---
}

//时间格式
.price-list ul li .time-content {
  // width: 127px; // ---
  // display: inline-block; // ---
  // margin-left: -110px; // ---
  flex: 1; // ---
}

.statustypea {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeb {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypec {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustyped {
  color: #fc8555;
  border: 1px solid #fc8555;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypee {
  color: #fc8555;
  border: 1px solid #fc8555;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypef {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeg {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeh {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypei {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}


@media screen and ( max-width: 1200px ){
.pricediv {
  width: 900px;
}

.price-content {
  width: 900px;
}

.price-title span.publish-time {
  margin-left: 255px;
}

.price-title span.organize {
  margin-left: 250px;
 //margin-left: 329px;
}

.price-list ul li .title-content {
  width: 309px;
}
.price-list ul li .organize-content {
  width: 174px;
}
}

</style>